import { RouteConfig } from 'vue-router';
import { RouteRoles } from '@/router/role-routes';
import { Analytics } from './types';

const routes: RouteConfig[] = [
  {
    path: `/${Analytics.Pages.ANALYTICS}`,
    name: Analytics.Pages.ANALYTICS,
    component: () => import(/* webpackChunkName: "analytics" */ './views/Analytics.vue'),
    meta: {
      access_roles: RouteRoles[Analytics.Pages.ANALYTICS],
    },
  },
];

export default routes;
